




































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppCarouselScroll from '@/components/AppCarouselScroll.vue'
import AppModal from '@/components/AppModal.vue'
import AppUrlLink from '@/components/AppUrlLink.vue'
import { Common } from '@/mixins'

@Component({
  components: {
    AppCarouselScroll,
    AppModal,
    AppUrlLink
  },
  apollo: {
    activePopupBanners: {
      query: gql`query activePopupBannersAtPopupBannerModal {
        activePopupBanners {
          id
          link
          startedAt
          endedAt
          media {
            id
            path
          }
        }
      }`,
      result () {
        if (!this.banners.length) {
          this.$emit('dismiss')
        }
      }
    }
  }
})
export default class extends Mixins(Common) {
  activePopupBanners: { startedAt: number; endedAt: number }[] = []
  indicatorNumber = 1
  now = Date.now() / 1000

  get banners () {
    return this.activePopupBanners.filter(banner => banner.startedAt <= this.now && this.now <= banner.endedAt)
  }

  visibilityChanged (isVisible: boolean, index: number) {
    if (isVisible) {
      this.indicatorNumber = index + 1
    }
  }

  onClickMuteToday () {
    localStorage.setItem('mutePopupBannerUntil', `${Date.now() / 1000 + 60 * 60 * 24}`)
    this.$emit('dismiss')
  }
}
